import { render, staticRenderFns } from "./ModalConfirmacao.vue?vue&type=template&id=31ea9768&scoped=true"
import script from "./ModalConfirmacao.vue?vue&type=script&lang=js"
export * from "./ModalConfirmacao.vue?vue&type=script&lang=js"
import style0 from "./ModalConfirmacao.vue?vue&type=style&index=0&id=31ea9768&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ea9768",
  null
  
)

export default component.exports